<template>
  <div class="section-board" :class="{ 'config-active': visibleDrawer }">
    <h3>Construir mi chatbot</h3>
    
    <CustomScrollbar v-if="treeNodes.length != 0 || loadingNodesChatbot" height="calc(100% - 55px)">
      <section
        class="section-board__body"
        :class="{ 'section-board__body--empty': treeNodes.length === 0 && !loadingNodesChatbot }"
      >
        <TreeSkeleton :rows="10" :maxLevel="3" v-if="loadingNodesChatbot" />
        <section
          class="section-board__body"
          :class="{ 'section-board__body--empty': treeNodes.length === 0 }"
          v-else
        >
          <container-tree
            :chatbotId="$route.params.id"
            :currentChannel="currentChannel"
            @onOpenDrawer="handleOpenDrawer"
            @preview="$emit('preview', $event)"
          />
        </section>
      </section>
    </CustomScrollbar>
    <div class="creator-section" v-else>
      <div class="subtitle">
        Selecciona una opción y agrega acciones que comuniquen mejor con tus contactos.
      </div>
      <div class="container-messages">
        <NodeCreatorCard
          v-if="channelHasNodeType(currentChannel.id, NodeType.Message)"
          :nodeType="NodeType.Message"
          @click="handleCreateNode"
        />

        <NodeCreatorCard
          v-if="channelHasNodeType(currentChannel.id, NodeType.Options)"
          :nodeType="NodeType.Options"
          @click="handleCreateNode"
        />

        <NodeCreatorCard
          v-if="channelHasNodeType(currentChannel.id, NodeType.Buttons)"
          :nodeType="NodeType.Buttons"
          @click="handleCreateNode"
        />
        <NodeCreatorCard
          v-if="channelHasNodeType(currentChannel.id, NodeType.List)"
          :nodeType="NodeType.List"
          @click="handleCreateNode"
        />
        <NodeCreatorCard
          v-if="channelHasNodeType(currentChannel.id, NodeType.Card)"
          :nodeType="NodeType.Card"
          @click="handleCreateNode"
        />
      </div>
    </div>
  </div>
</template>

<script>
import { inject, nextTick, onMounted, ref } from "vue";
import { mapGetters } from "vuex";

import { NodeType, StatusProps } from "@/app/chatbots/utils/enums";
import { channelHasNodeType } from "@/app/chatbots/utils/helpers";
import { dateTimeToSlashFormat } from "@/app/shared/utils/dates";
import { ChannelType } from "@/app/shared/utils/enums";

import CustomScrollbar from "@/app/shared/components/organisms/CustomScrollbar.vue";
import ContainerTree from "@/app/chatbots/components/tree/ContainerTree.vue";
import NodeCreatorCard from "@/app/chatbots/components/cards/NodeCreatorCard.vue";
import TreeSkeleton from "@/app/shared/components/skeletons/TreeSkeleton.vue";

export default {
  name: "SectionBoard",
  components: {
    CustomScrollbar,
    ContainerTree,
    NodeCreatorCard,
    TreeSkeleton,
  },
  props: {
    visibleDrawer: { type: Boolean, default: false },
    currentChannel: { type: Object, default: () => ({}) },
  },
  setup() {
    const showNodeOptions = ref(false);
    const chatbotDetails = inject("chatbotDetails");

    onMounted(async () => {
      await nextTick();
      showNodeOptions.value = true;
    });

    return {
      chatbotDetails,
      NodeType,
      dateTimeToSlashFormat,
      ChannelType,
      channelHasNodeType,
      showNodeOptions,
    };
  },
  data: () => ({
    count: 0,
    StatusProps,
  }),
  computed: {
    ...mapGetters(["nodes"]),

    treeNodes() {
      return this.$store.getters["getChatbotNodes"];
    },
    loadingNodesChatbot() {
      return this.$store.getters["getLoadingNodesChatbot"];
    }
  },
  watch: {
    nodes: {
      deep: true,
      handler: function () {
        this.$nextTick(() => this.count++);
      },
    },
  },
  methods: {
    handleOpenDrawer(settings) {
      this.$emit("onOpenDrawer", settings);
    },
    handleCreateNode(nodeType) {
      this.$emit("create-node", { nodeType });
    },
  },
};
</script>

<style lang="sass" scoped>
.name-status
  display: flex
  gap: 12px

.section-board
  height: 100%
  border-top: 1px solid $gray-5
  background-color: #FFFFFF

  &.config-active
    border-radius: 0 8px 8px 0
    border-right: 1px solid $gray-5

  &__header
    padding: 12px 20px
    border-bottom: 1px solid $gray-5
  &__title
    text-align: left
    font-size: 16px
    color: #262626
    margin: 0
  &__actions
    width: 100%
    display: flex
  &__action
    margin-right: 12px
    color: #8C8C8C
    font-style: italic
  &__body
    padding: 12px 20px
    &--empty
      height: 500px
      display: flex
      align-items: center
      justify-content: center

.skeleton-loading
  padding: 12px 20px
.subtitle
  font-size: 14px
  color: #595959
  margin-bottom: 14px

.container-messages
  display: flex
  justify-content: center
  gap: 25px
  flex-wrap: wrap

.creator-section
  text-align: center

h3
  color: $gray-9
  font-size: 16px
  font-weight: 400
  border-bottom: 1px solid $gray-5
  padding: 0 20px 10px
  margin: 10px 0
</style>
